import { render, staticRenderFns } from "./AuditsList.vue?vue&type=template&id=2b62a9a8"
import script from "./AuditsList.vue?vue&type=script&lang=ts"
export * from "./AuditsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports